import React from 'react'
import { Row, Col, Skeleton } from 'antd'

import boardStyles from '../projectDetail.module.css'
import styles from './KanbanBoardSkeleton.module.css'

const COLUMN_COUNT = 5
const CARDS_PER_COLUMN = [4, 3, 4, 3, 4]

const KanbanBoardSkeleton = () => (
    <div className={styles.root} aria-busy="true" aria-label="Loading tasks">
        <div className={boardStyles.kanbanBoardContainer}>
            <Row wrap={false} gutter={14} className={boardStyles.kanbanBoardRow}>
                {Array.from({ length: COLUMN_COUNT }).map((_, columnIndex) => (
                    <Col key={columnIndex} className={boardStyles.kanbanColumn}>
                        <div className={boardStyles.swimlane}>
                            <div className={styles.columnHeader}>
                                <Skeleton.Input
                                    active
                                    size="small"
                                    className={styles.columnTitleSk}
                                />
                                <Skeleton.Avatar
                                    active
                                    size={18}
                                    shape="circle"
                                    className={styles.columnCountSk}
                                />
                            </div>
                            {Array.from({
                                length: CARDS_PER_COLUMN[columnIndex] || 3,
                            }).map((__, cardIndex) => (
                                <div
                                    key={cardIndex}
                                    className={boardStyles.taskCardNew}
                                    style={{
                                        cursor: 'default',
                                        pointerEvents: 'none',
                                    }}
                                >
                                    <div className={styles.cardBody}>
                                        <Skeleton
                                            active
                                            title={{ width: '82%' }}
                                            paragraph={false}
                                        />
                                        <div className={styles.cardMeta}>
                                            <Skeleton.Avatar
                                                active
                                                size={28}
                                                shape="circle"
                                            />
                                            <Skeleton.Input
                                                active
                                                size="small"
                                                className={styles.cardDateSk}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    </div>
)

export default KanbanBoardSkeleton
